/* eslint-disable @next/next/no-img-element */
import clsx from "clsx";
import { forwardRef } from "react";
import { motion } from "framer-motion";
import styles from "./index.module.css";
import { GeneralPropsType } from "@/common/types";
import { useGlobalData } from "@/contexts/GlobalData";
export interface DynamicSizeIconPropsType extends GeneralPropsType {
  icon?: string;
  width: number;
  height?: number;
}
export default motion(forwardRef<HTMLDivElement, DynamicSizeIconPropsType>(function DynamicSizeIcon({
  icon,
  width,
  height,
  className,
  ...rest
}: DynamicSizeIconPropsType, ref) {
  const {
    isLimitSize,
    screenSize
  } = useGlobalData();
  const scale = 1.5;
  return !!icon && <div ref={ref} {...rest} className={clsx(`relative inline-block bg-no-repeat bg-contain bg-center`, styles.container, className)} icon-data={icon} style={{
    aspectRatio: width / (height ?? width),
    width: isLimitSize ? `clamp(${width}px,calc(${width / 375}*${screenSize?.realWidth / (screenSize?.width ?? 390) * 100}vw),${scale * width}px)` : `clamp(${width}px,calc(${width / 375}*100vw),${scale * width}px)`,
    backgroundImage: `url(${icon})`,
    minWidth: width + "px",
    minHeight: height ?? width + "px"
  }}>
                    {/* <img src={icon} alt="" className="absolute inset-0" /> */}
                </div>;
}));